<template>
  <div>
    <v-list-tile>
      <v-list-tile-content>
        <v-list-tile-title>{{ name }}</v-list-tile-title>
        <v-list-tile-sub-title>{{ value }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  name: "HostEnvironmentLine",
  props: ["name", "value"]
};
</script>

<style scoped></style>
